import { Box, Text, useResponsiveValue } from 'braid-design-system';
import { useRef } from 'react';

import useJobSearchAssist from 'src/components/Search/JobSearchAssistContext';
import { useAnalyticsFacade } from 'src/modules/AnalyticsFacade/react.ts';
import { useSelector } from 'src/store/react.ts';
import { selectSolMetadata } from 'src/store/results/selectors';
import { selectDynamicSearchBarConfiguration } from 'src/store/search/selectors';

import { type OnPillSelectProps, Pills } from './components/Pills/Pills';

import * as styles from './DynamicPillV2.css';

export const DynamicPillV2 = () => {
  const { pills, isLoading, onPillClick } = useJobSearchAssist();
  const solMetadata = useSelector(selectSolMetadata);
  const ref = useRef<HTMLDivElement>(null);
  const analyticsFacade = useAnalyticsFacade();

  const isMobile =
    useResponsiveValue()({
      mobile: true,
      tablet: false,
    }) || false;

  const dynamicSearchBarConfiguration = useSelector(
    selectDynamicSearchBarConfiguration,
  );

  const handleOnPillClick = ({
    isActive,
    keywords,
    label,
    position,
    stateToken,
  }: OnPillSelectProps) => {
    analyticsFacade.refinementSuggestionClicked({
      solMetadata,
      refinedKeywords: [
        {
          isActive,
          label,
          position,
          type: 'OTHER',
        },
      ],
      searchBarConfiguration: dynamicSearchBarConfiguration,
    });

    onPillClick({ keywords, stateToken });
  };

  const hasPills = pills && pills?.length > 0;

  if (!hasPills) {
    return null;
  }

  if (isLoading) {
    return (
      <Box
        data={{ automation: 'dynamicPillsPlaceHolder' }}
        paddingY="xxsmall"
        opacity={0}
      >
        <Text
          baseline={false}
          maxLines={1}
          size={isMobile ? 'small' : 'standard'}
        >
          Placeholder
        </Text>
      </Box>
    );
  }

  return (
    <Box
      data={{ automation: 'dynamicPills' }}
      display="flex"
      position="relative"
      alignItems="center"
      className={{
        [styles.dotSeparator]: true,
        [styles.bleedPillsAcrossBorder]: isMobile,
      }}
    >
      <Pills handleOnPillClick={handleOnPillClick} pills={pills} ref={ref} />
    </Box>
  );
};
